<template>
  <div class="rc-wrapper rc-catalog-detail-layout">
    <rc-skip-nav/>
    <rc-auth-status-banner />
    <rc-site-header />
    <rc-site-background :imageUrl="previewedItemBgImage" />
    <div class="main-container">
      <rc-site-content />
    </div>
    <rc-site-footer />
    <rc-notifications />
  </div>
</template>

<script>
import { mapState } from "vuex";
import SkipNav from "@/libvue/components/skipnav/SkipNav.vue";
import SiteBackground from "#/layout/components/SiteBackground.vue";
import SiteContent from "#/layout/components/SiteContent.vue";
import SiteHeader from "#/layout/components/SiteHeader.vue";
import SiteFooter from "#/layout/components/SiteFooter.vue";
import AuthStatusBanner from "@/libvue/apps/auth/components/StatusBanner.vue";

export default {
  name: "DetailLayout",
  components: {
    "rc-skip-nav": SkipNav,
    "rc-site-background": SiteBackground,
    "rc-site-content": SiteContent,
    "rc-site-footer": SiteFooter,
    "rc-site-header": SiteHeader,
    "rc-auth-status-banner": AuthStatusBanner
  },
  computed: {
    ...mapState({
      previewedItemBgImage: state =>
        state.catalog.previewedItem &&
        state.catalog.previewedItem &&
        state.catalog.previewedItem.image_bg
          ? state.catalog.previewedItem.image_bg
          : undefined
    })
  }
};
</script>
